var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15892 4.52731H1.58605V10.0616H1.3907C0.905159 10.0616 0.5 9.65854 0.5 9.16136V5.19414C0.5 4.82298 0.798539 4.52731 1.15892 4.52731Z",
    fill: "white",
    stroke: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73695 1.0451L8.80134 1.0059L8.85728 0.95537C8.96243 0.860388 9.09389 0.806546 9.23147 0.800107C9.48735 0.805054 9.63141 0.980513 9.63257 1.1686V12.7814C9.63257 13.0261 9.44277 13.1963 9.25237 13.1997L9.24938 13.1998C9.02521 13.2047 8.80566 13.1218 8.63972 12.9694L8.58678 12.9208L8.52602 12.8824L3.81318 9.90278V4.04185L8.73695 1.0451Z",
    fill: "white",
    stroke: "#393939",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1397 4.81405C11.9535 4.62782 11.9535 4.32589 12.1397 4.13967C12.3259 3.95344 12.6278 3.95344 12.8141 4.13967L16.8604 8.18595C17.0466 8.37218 17.0466 8.67411 16.8604 8.86033C16.6741 9.04656 16.3722 9.04656 16.186 8.86033L12.1397 4.81405Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.186 4.13967C16.3722 3.95344 16.6741 3.95344 16.8603 4.13967C17.0466 4.32589 17.0466 4.62782 16.8603 4.81405L12.814 8.86033C12.6278 9.04656 12.3259 9.04656 12.1397 8.86033C11.9534 8.67411 11.9534 8.37218 12.1397 8.18595L16.186 4.13967Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceOff);
export default __webpack_public_path__ + "static/media/voice_off.59a224e8ccc00de1ed5be0672ccbccbf.svg";
export { ForwardRef as ReactComponent };